<template>
  <div class="sub-menu-sustainability sub-menu">
    <!-- Content -->
    <div
      v-if="content?.sustainability?.text_long"
      class="sub-menu-sustainability__text"
    >
      <div
        class="
          text-desktop-small-desktop
          text-mobile-small-mobile
          sub-menu-sustainability__text-content
          rte
        "
        v-html="productContentDetails"
      />
    </div>

    <div
      v-if="content?.sustainability?.display_certified"
      class="sub-menu-sustainability__svg"
    >
      <certified-icon :icon-name="content.sustainability.display_certified" />
    </div>

    <!-- Links content -->
    <div
      v-if="createLinks.length"
      class="sub-menu-sustainability__links"
    >
      <clickable-list
        ref="sustainabilityLinks"
        display-icons
        :links="createLinks"
        @mouseleave="resetList"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu sustainability
 * -----------------------------------------------------------------------------
 * Sustainability sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 *
 */
import ClickableList from '~global/clickable-list/clickable-list'
import CertifiedIcon from './certified-icon/certified-icon'

export default {
  name: 'SubMenuSustainability',

  components: {
    ClickableList,
    CertifiedIcon,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    productContentDetails() {
      const parser = new DOMParser()
      const decodedString = parser.parseFromString(this.content.sustainability.text_long, 'text/html').body.textContent
      return decodedString
    },

    /**
     * Builds a list of links to be fed into a clickable-list component.
     * @returns {Array}
     */
    createLinks() {
      if (!this.content?.sustainability?.links?.length) {
        return []
      }

      return this.content.sustainability.links.reduce((agg, link) => {
        const parts = link.split('||')
        agg.push({
          link: parts[1]?.trim() ?? '#',
          label: parts[0]?.trim(),
        })
        return agg
      }, [])
    },
  },

  methods: {

    /**
     * Resets the linklist in the component on mouseleave.
     */
    resetList() {
      const links = this.$refs.sustainabilityLinks

      if (!links) {
        return
      }

      links.resetComponentData()
    },
  },
}
</script>
